import outlander_interior_1_sm from '../../../assets/vehicles/outlander/outlander-interior-1-sm.jpg'
import outlander_interior_1_lg from '../../../assets/vehicles/outlander/outlander-interior-1-lg.jpg'
import outlander_2026_interior_2_sm from '../../../assets/vehicles/outlander/outlander-2026-interior-2-sm.jpg'
import outlander_2026_interior_2_lg from '../../../assets/vehicles/outlander/outlander-2026-interior-2-lg.jpg'

import outlander_exterior_virtual_tour from '../../../assets/vehicles/outlander/outlander-exterior-virtual-tour.jpg'
import outlander_exterior_01_sm from '../../../assets/vehicles/outlander/outlander-exterior-01-sm.png'
import outlander_exterior_01_lg from '../../../assets/vehicles/outlander/outlander-exterior-01-lg.png'
import outlander_exterior_02_sm from '../../../assets/vehicles/outlander/outlander-exterior-02-sm.png'
import outlander_exterior_02_lg from '../../../assets/vehicles/outlander/outlander-exterior-02-lg.png'
import outlander_exterior_03_sm from '../../../assets/vehicles/outlander/outlander-exterior-03-sm.png'
import outlander_exterior_03_lg from '../../../assets/vehicles/outlander/outlander-exterior-03-lg.png'
import outlander_exterior_04_sm from '../../../assets/vehicles/outlander/outlander-exterior-04-sm.png'
import outlander_exterior_04_lg from '../../../assets/vehicles/outlander/outlander-exterior-04-lg.png'
import outlander_exterior_05_sm from '../../../assets/vehicles/outlander/outlander-exterior-05-sm.png'
import outlander_exterior_05_lg from '../../../assets/vehicles/outlander/outlander-exterior-05-lg.png'
import outlander_exterior_06_sm from '../../../assets/vehicles/outlander/outlander-exterior-06-sm.png'
import outlander_exterior_06_lg from '../../../assets/vehicles/outlander/outlander-exterior-06-lg.png'
import outlander_exterior_07_sm from '../../../assets/vehicles/outlander/outlander-exterior-07-sm.png'
import outlander_exterior_07_lg from '../../../assets/vehicles/outlander/outlander-exterior-07-lg.png'
import outlander_exterior_08_sm from '../../../assets/vehicles/outlander/outlander-exterior-08-sm.png'
import outlander_exterior_08_lg from '../../../assets/vehicles/outlander/outlander-exterior-08-lg.png'
import outlander_exterior_09_sm from '../../../assets/vehicles/outlander/outlander-exterior-09-sm.png'
import outlander_exterior_09_lg from '../../../assets/vehicles/outlander/outlander-exterior-09-lg.png'
import outlander_exterior_10_sm from '../../../assets/vehicles/outlander/outlander-exterior-10-sm.png'
import outlander_exterior_10_lg from '../../../assets/vehicles/outlander/outlander-exterior-10-lg.png'
import outlander_exterior_11_sm from '../../../assets/vehicles/outlander/outlander-exterior-11-sm.png'
import outlander_exterior_11_lg from '../../../assets/vehicles/outlander/outlander-exterior-11-lg.png'
import outlander_exterior_12_sm from '../../../assets/vehicles/outlander/outlander-exterior-12-sm.png'
import outlander_exterior_12_lg from '../../../assets/vehicles/outlander/outlander-exterior-12-lg.png'
import outlander_exterior_13_sm from '../../../assets/vehicles/outlander/outlander-exterior-13-sm.png'
import outlander_exterior_13_lg from '../../../assets/vehicles/outlander/outlander-exterior-13-lg.png'
import outlander_exterior_14_sm from '../../../assets/vehicles/outlander/outlander-exterior-14-sm.png'
import outlander_exterior_14_lg from '../../../assets/vehicles/outlander/outlander-exterior-14-lg.png'
import outlander_exterior_15_sm from '../../../assets/vehicles/outlander/outlander-exterior-15-sm.png'
import outlander_exterior_15_lg from '../../../assets/vehicles/outlander/outlander-exterior-15-lg.png'
import outlander_exterior_16_sm from '../../../assets/vehicles/outlander/outlander-exterior-16-sm.png'
import outlander_exterior_16_lg from '../../../assets/vehicles/outlander/outlander-exterior-16-lg.png'

import outlander_safety_airbags_1 from '../../../assets/vehicles/outlander/outlander-safety-airbags-1.svg'
import outlander_safety_airbags_2 from '../../../assets/vehicles/outlander/outlander-safety-airbags-2.svg'

export const data = {
  virtualCardImage: {
    interior: outlander_interior_1_sm,
    exterior: outlander_exterior_virtual_tour,
  },
  interiorSlides: [
    {
      image: {
        sm: outlander_interior_1_sm,
        lg: outlander_interior_1_lg,
      },
      hotspots: [
        {
          x: 26,
          y: 22,
          action: '??',
          label: 'outlander.interior.image-1.hotspot-1.label',
          message: 'outlander.interior.image-1.hotspot-1.message',
          position: 'bottom',
        },
        {
          x: 56,
          y: 48,
          action: '??',
          label: 'outlander.interior.image-1.hotspot-2.label',
          message: 'outlander.interior.image-1.hotspot-2.message',
          position: 'bottom',
        },
        {
          x: 54,
          y: 63,
          action: '??',
          label: 'outlander.interior.image-1.hotspot-3.label',
          message: 'outlander.interior.image-1.hotspot-3.message',
          position: 'left',
        },
        {
          x: 33,
          y: 74,
          action: '??',
          label: 'outlander.interior.image-1.hotspot-4.label',
          message: 'outlander.interior.image-1.hotspot-4.message',
          position: 'bottom',
        },
      ],
    },
    {
      image: {
        sm: outlander_2026_interior_2_sm,
        lg: outlander_2026_interior_2_lg,
      },
      hotspots: [
        {
          x: 12,
          y: 48,
          action: '??',
          label: 'outlander.interior.image-2.hotspot-1.label',
          message: 'outlander.interior.image-2.hotspot-1.message',
          position: 'top',
        },
        {
          x: 41,
          y: 70,
          action: '??',
          label: 'outlander.interior.image-2.hotspot-2.label',
          message: 'outlander.interior.image-2.hotspot-2.message',
          position: 'top',
        },
        {
          x: 79,
          y: 62,
          action: '??',
          label: 'outlander.interior.image-2.hotspot-3.label',
          message: 'outlander.interior.image-2.hotspot-3.message',
          position: 'bottom',
        },
        {
          x: 63.5,
          y: 58,
          action: '??',
          label: 'outlander.interior.image-2.hotspot-4.label',
          message: 'outlander.interior.image-2.hotspot-4.message',
          position: 'top',
        },
      ],
    },
  ],
  exteriorSlides: [
    {
      image: {
        sm: outlander_exterior_01_sm,
        lg: outlander_exterior_01_lg,
      },
      hotspots: [
        {
          x: 22,
          y: 52,
          action: '??',
          label: 'outlander.exterior.hotspot-1.label',
          message: 'outlander.exterior.hotspot-1.message',
          position: 'bottom',
        },
        {
          x: 48,
          y: 37,
          action: '??',
          label: 'outlander.exterior.hotspot-2.label',
          message: 'outlander.exterior.hotspot-2.message',
          position: 'bottom',
        },
        {
          x: 48,
          y: 51,
          action: '??',
          label: 'outlander.exterior.hotspot-3.label',
          message: 'outlander.exterior.hotspot-3.message',
          position: 'top',
        },
        {
          x: 64,
          y: 72,
          action: '??',
          label: 'outlander.exterior.hotspot-4.label',
          message: 'outlander.exterior.hotspot-4.message',
          position: 'top',
        },
      ],
    },
    {
      image: {
        sm: outlander_exterior_02_sm,
        lg: outlander_exterior_02_lg,
      },
      hotspots: [
        {
          x: 46,
          y: 38,
          action: '??',
          label: 'outlander.exterior.hotspot-2.label',
          message: 'outlander.exterior.hotspot-2.message',
          position: 'bottom',
        },
        {
          x: 45,
          y: 50,
          action: '??',
          label: 'outlander.exterior.hotspot-3.label',
          message: 'outlander.exterior.hotspot-3.message',
          position: 'top',
        },
        {
          x: 70,
          y: 38,
          action: '??',
          label: 'outlander.exterior.hotspot-5.label',
          message: 'outlander.exterior.hotspot-5.message',
          position: 'bottom',
        },
        {
          x: 72,
          y: 65,
          action: '??',
          label: 'outlander.exterior.hotspot-6.label',
          message: 'outlander.exterior.hotspot-6.message',
          position: 'top',
        },
      ],
    },
    {
      image: {
        sm: outlander_exterior_03_sm,
        lg: outlander_exterior_03_lg,
      },
      hotspots: [
        {
          x: 49,
          y: 38,
          action: '??',
          label: 'outlander.exterior.hotspot-2.label',
          message: 'outlander.exterior.hotspot-2.message',
          position: 'bottom',
        },
        {
          x: 43,
          y: 50,
          action: '??',
          label: 'outlander.exterior.hotspot-3.label',
          message: 'outlander.exterior.hotspot-3.message',
          position: 'top',
        },
        {
          x: 69,
          y: 38,
          action: '??',
          label: 'outlander.exterior.hotspot-5.label',
          message: 'outlander.exterior.hotspot-5.message',
          position: 'bottom',
        },
        {
          x: 67,
          y: 66,
          action: '??',
          label: 'outlander.exterior.hotspot-6.label',
          message: 'outlander.exterior.hotspot-6.message',
          position: 'top',
        },
      ],
    },
    {
      image: {
        sm: outlander_exterior_04_sm,
        lg: outlander_exterior_04_lg,
      },
      hotspots: [
        {
          x: 46,
          y: 38,
          action: '??',
          label: 'outlander.exterior.hotspot-2.label',
          message: 'outlander.exterior.hotspot-2.message',
          position: 'bottom',
        },
        {
          x: 64,
          y: 38,
          action: '??',
          label: 'outlander.exterior.hotspot-5.label',
          message: 'outlander.exterior.hotspot-5.message',
          position: 'bottom',
        },
        {
          x: 68,
          y: 53,
          action: '??',
          label: 'outlander.exterior.hotspot-7.label',
          message: 'outlander.exterior.hotspot-7.message',
          position: 'left',
        },
        {
          x: 55,
          y: 68,
          action: '??',
          label: 'outlander.exterior.hotspot-6.label',
          message: 'outlander.exterior.hotspot-6.message',
          position: 'left',
        },
      ],
    },
    {
      image: {
        sm: outlander_exterior_05_sm,
        lg: outlander_exterior_05_lg,
      },
      hotspots: [
        {
          x: 45,
          y: 37,
          action: '??',
          label: 'outlander.exterior.hotspot-5.label',
          message: 'outlander.exterior.hotspot-5.message',
          position: 'bottom',
        },
        {
          x: 59,
          y: 53,
          action: '??',
          label: 'outlander.exterior.hotspot-7.label',
          message: 'outlander.exterior.hotspot-7.message',
          position: 'left',
        },
        {
          x: 51,
          y: 68,
          action: '??',
          label: 'outlander.exterior.hotspot-6.label',
          message: 'outlander.exterior.hotspot-6.message',
          position: 'left',
        },
      ],
    },
    {
      image: {
        sm: outlander_exterior_06_sm,
        lg: outlander_exterior_06_lg,
      },
      hotspots: [
        {
          x: 36,
          y: 38,
          action: '??',
          label: 'outlander.exterior.hotspot-5.label',
          message: 'outlander.exterior.hotspot-5.message',
          position: 'bottom',
        },
        {
          x: 48,
          y: 45,
          action: '??',
          label: 'outlander.exterior.hotspot-7.label',
          message: 'outlander.exterior.hotspot-7.message',
          position: 'bottom',
        },
        {
          x: 43,
          y: 68,
          action: '??',
          label: 'outlander.exterior.hotspot-6.label',
          message: 'outlander.exterior.hotspot-6.message',
          position: 'right',
        },
        {
          x: 55,
          y: 71,
          action: '??',
          label: 'outlander.exterior.hotspot-4.label',
          message: 'outlander.exterior.hotspot-4.message',
          position: 'left',
        },
      ],
    },
    {
      image: {
        sm: outlander_exterior_07_sm,
        lg: outlander_exterior_07_lg,
      },
      hotspots: [
        {
          x: 31,
          y: 38,
          action: '??',
          label: 'outlander.exterior.hotspot-5.label',
          message: 'outlander.exterior.hotspot-5.message',
          position: 'bottom',
        },
        {
          x: 43,
          y: 46,
          action: '??',
          label: 'outlander.exterior.hotspot-7.label',
          message: 'outlander.exterior.hotspot-7.message',
          position: 'bottom',
        },
        {
          x: 35,
          y: 67,
          action: '??',
          label: 'outlander.exterior.hotspot-6.label',
          message: 'outlander.exterior.hotspot-6.message',
          position: 'top',
        },
        {
          x: 69,
          y: 69,
          action: '??',
          label: 'outlander.exterior.hotspot-4.label',
          message: 'outlander.exterior.hotspot-4.message',
          position: 'top',
        },
      ],
    },
    {
      image: {
        sm: outlander_exterior_08_sm,
        lg: outlander_exterior_08_lg,
      },
      hotspots: [
        {
          x: 36,
          y: 46,
          action: '??',
          label: 'outlander.exterior.hotspot-7.label',
          message: 'outlander.exterior.hotspot-7.message',
          position: 'bottom',
        },
        {
          x: 28,
          y: 66,
          action: '??',
          label: 'outlander.exterior.hotspot-6.label',
          message: 'outlander.exterior.hotspot-6.message',
          position: 'top',
        },
        {
          x: 70,
          y: 69,
          action: '??',
          label: 'outlander.exterior.hotspot-4.label',
          message: 'outlander.exterior.hotspot-4.message',
          position: 'top',
        },
        {
          x: 64,
          y: 46,
          action: '??',
          label: 'outlander.exterior.hotspot-8.label',
          message: 'outlander.exterior.hotspot-8.message',
          position: 'bottom',
        },
      ],
    },
    {
      image: {
        sm: outlander_exterior_09_sm,
        lg: outlander_exterior_09_lg,
      },
      hotspots: [
        {
          x: 49,
          y: 38,
          action: '??',
          label: 'outlander.exterior.hotspot-2.label',
          message: 'outlander.exterior.hotspot-2.message',
          position: 'bottom',
        },
        {
          x: 79,
          y: 56,
          action: '??',
          label: 'outlander.exterior.hotspot-1.label',
          message: 'outlander.exterior.hotspot-1.message',
          position: 'right',
        },
        {
          x: 35,
          y: 72,
          action: '??',
          label: 'outlander.exterior.hotspot-4.label',
          message: 'outlander.exterior.hotspot-4.message',
          position: 'top',
        },
        {
          x: 61,
          y: 46,
          action: '??',
          label: 'outlander.exterior.hotspot-8.label',
          message: 'outlander.exterior.hotspot-8.message',
          position: 'bottom',
        },
      ],
    },
    {
      image: {
        sm: outlander_exterior_10_sm,
        lg: outlander_exterior_10_lg,
      },
      hotspots: [
        {
          x: 47,
          y: 38,
          action: '??',
          label: 'outlander.exterior.hotspot-2.label',
          message: 'outlander.exterior.hotspot-2.message',
          position: 'bottom',
        },
        {
          x: 78,
          y: 56,
          action: '??',
          label: 'outlander.exterior.hotspot-1.label',
          message: 'outlander.exterior.hotspot-1.message',
          position: 'right',
        },
        {
          x: 34,
          y: 72,
          action: '??',
          label: 'outlander.exterior.hotspot-4.label',
          message: 'outlander.exterior.hotspot-4.message',
          position: 'top',
        },
        {
          x: 56,
          y: 46,
          action: '??',
          label: 'outlander.exterior.hotspot-8.label',
          message: 'outlander.exterior.hotspot-8.message',
          position: 'bottom',
        },
      ],
    },
    {
      image: {
        sm: outlander_exterior_11_sm,
        lg: outlander_exterior_11_lg,
      },
      hotspots: [
        // {
        //   x: 58,
        //   y: 39,
        //   action: '??',
        //   label: 'outlander.exterior.hotspot-9.label',
        //   message: 'outlander.exterior.hotspot-9.message',
        //   position: 'bottom',
        // },
        {
          x: 74,
          y: 56,
          action: '??',
          label: 'outlander.exterior.hotspot-1.label',
          message: 'outlander.exterior.hotspot-1.message',
          position: 'right',
        },
        {
          x: 33,
          y: 72,
          action: '??',
          label: 'outlander.exterior.hotspot-4.label',
          message: 'outlander.exterior.hotspot-4.message',
          position: 'top',
        },
        {
          x: 50,
          y: 46,
          action: '??',
          label: 'outlander.exterior.hotspot-8.label',
          message: 'outlander.exterior.hotspot-8.message',
          position: 'right',
        },
      ],
    },
    {
      image: {
        sm: outlander_exterior_12_sm,
        lg: outlander_exterior_12_lg,
      },
      hotspots: [
        // {
        //   x: 58,
        //   y: 40,
        //   action: '??',
        //   label: 'outlander.exterior.hotspot-9.label',
        //   message: 'outlander.exterior.hotspot-9.message',
        //   position: 'left',
        // },
        {
          x: 69,
          y: 56,
          action: '??',
          label: 'outlander.exterior.hotspot-1.label',
          message: 'outlander.exterior.hotspot-1.message',
          position: 'top',
        },
        {
          x: 51,
          y: 38,
          action: '??',
          label: 'outlander.exterior.hotspot-2.label',
          message: 'outlander.exterior.hotspot-2.message',
          position: 'bottom',
        },
        {
          x: 43,
          y: 46,
          action: '??',
          label: 'outlander.exterior.hotspot-8.label',
          message: 'outlander.exterior.hotspot-8.message',
          position: 'right',
        },
      ],
    },
    {
      image: {
        sm: outlander_exterior_13_sm,
        lg: outlander_exterior_13_lg,
      },
      hotspots: [
        // {
        //   x: 58,
        //   y: 41,
        //   action: '??',
        //   label: 'outlander.exterior.hotspot-9.label',
        //   message: 'outlander.exterior.hotspot-9.message',
        //   position: 'left',
        // },
        {
          x: 60,
          y: 58,
          action: '??',
          label: 'outlander.exterior.hotspot-1.label',
          message: 'outlander.exterior.hotspot-1.message',
          position: 'left',
        },
        {
          x: 51,
          y: 38,
          action: '??',
          label: 'outlander.exterior.hotspot-2.label',
          message: 'outlander.exterior.hotspot-2.message',
          position: 'bottom',
        },
        {
          x: 39,
          y: 46,
          action: '??',
          label: 'outlander.exterior.hotspot-8.label',
          message: 'outlander.exterior.hotspot-8.message',
          position: 'right',
        },
      ],
    },
    {
      image: {
        sm: outlander_exterior_14_sm,
        lg: outlander_exterior_14_lg,
      },
      hotspots: [
        // {
        //   x: 39,
        //   y: 43,
        //   action: '??',
        //   label: 'outlander.exterior.hotspot-9.label',
        //   message: 'outlander.exterior.hotspot-9.message',
        //   position: 'right',
        // },
        {
          x: 30,
          y: 58,
          action: '??',
          label: 'outlander.exterior.hotspot-1.label',
          message: 'outlander.exterior.hotspot-1.message',
          position: 'right',
        },
        {
          x: 50,
          y: 37,
          action: '??',
          label: 'outlander.exterior.hotspot-2.label',
          message: 'outlander.exterior.hotspot-2.message',
          position: 'bottom',
        },
        {
          x: 64,
          y: 68,
          action: '??',
          label: 'outlander.exterior.hotspot-4.label',
          message: 'outlander.exterior.hotspot-4.message',
          position: 'top',
        },
      ],
    },
    {
      image: {
        sm: outlander_exterior_15_sm,
        lg: outlander_exterior_15_lg,
      },
      hotspots: [
        // {
        //   x: 39,
        //   y: 43,
        //   action: '??',
        //   label: 'outlander.exterior.hotspot-9.label',
        //   message: 'outlander.exterior.hotspot-9.message',
        //   position: 'right',
        // },
        {
          x: 24,
          y: 58,
          action: '??',
          label: 'outlander.exterior.hotspot-1.label',
          message: 'outlander.exterior.hotspot-1.message',
          position: 'left',
        },
        {
          x: 50,
          y: 37,
          action: '??',
          label: 'outlander.exterior.hotspot-2.label',
          message: 'outlander.exterior.hotspot-2.message',
          position: 'bottom',
        },
        {
          x: 67,
          y: 69,
          action: '??',
          label: 'outlander.exterior.hotspot-4.label',
          message: 'outlander.exterior.hotspot-4.message',
          position: 'top',
        },
      ],
    },
    {
      image: {
        sm: outlander_exterior_16_sm,
        lg: outlander_exterior_16_lg,
      },
      hotspots: [
        {
          x: 54,
          y: 50,
          action: '??',
          label: 'outlander.exterior.hotspot-3.label',
          message: 'outlander.exterior.hotspot-3.message',
          position: 'left',
        },
        {
          x: 22,
          y: 58,
          action: '??',
          label: 'outlander.exterior.hotspot-1.label',
          message: 'outlander.exterior.hotspot-1.message',
          position: 'top',
        },
        {
          x: 50,
          y: 37,
          action: '??',
          label: 'outlander.exterior.hotspot-2.label',
          message: 'outlander.exterior.hotspot-2.message',
          position: 'bottom',
        },
        {
          x: 67,
          y: 69,
          action: '??',
          label: 'outlander.exterior.hotspot-4.label',
          message: 'outlander.exterior.hotspot-4.message',
          position: 'top',
        },
      ],
    },
  ],
  safetyTabs: [
    {
      label: 'outlander.blueprint.safety.tab-1',
      image: outlander_safety_airbags_1,
      dots: [
        {
          top: -9,
          left: 49,
          label: 'outlander.blueprint.safety.hotspot-1.label',
          message: 'outlander.blueprint.safety.hotspot-1.message',
          position: 'right',
        },
        {
          top: 13,
          left: 2,
          label: 'outlander.blueprint.safety.hotspot-2.label',
          message: 'outlander.blueprint.safety.hotspot-2.message',
          position: 'left',
        },
        {
          top: 25,
          left: 47,
          label: 'outlander.blueprint.safety.hotspot-3.label',
          message: 'outlander.blueprint.safety.hotspot-3.message',
          position: 'top',
        },
      ],
    },
    {
      label: 'outlander.blueprint.safety.tab-2',
      image: outlander_safety_airbags_2,
      dots: [
        {
          top: 11,
          left: 54,
          label: 'outlander.blueprint.safety.hotspot-4.label',
          message: 'outlander.blueprint.safety.hotspot-4.message',
          position: 'top',
        },
        {
          top: 67,
          left: 27,
          label: 'outlander.blueprint.safety.hotspot-5.label',
          message: 'outlander.blueprint.safety.hotspot-5.message',
          position: 'top',
        },
      ],
    },
  ],
}
